import React,{ useState,useEffect } from 'react';
import MenuProductView from './MenuProductView';
import MenuAdjustability from './MenuAdjustability';
import AnimationBtn from './AnimationBtn';
import MenuFeatures from './MenuFeatures';
import Howtousenew from './Howtousenew';
import HowToUse from './HowToUse';
import FooterControl from './FooterControl';
import FooterControlMob from './FooterControlMob';
import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button';

// import MenuBtn from './MenuBtn';
// import { MicNone } from '@material-ui/icons';
var mob = (navigator.userAgent.indexOf("iPhone") != -1) || ((navigator.userAgent.indexOf("Android") != -1) || (navigator.userAgent.indexOf("Mobile") != -1)) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15");
var mobPortrait = (mob && window.innerHeight > window.innerWidth);
var moblandscap = (mob && window.innerWidth > window.innerHeight);
var isipad = navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1);

export const userContext = React.createContext();
var prevCounter = 0;
var nextClicked = false;
var prevClicked = false;
var buttonSeq = ['onResetMode','onfrontClick','onPortClick','pivotAnimation','swivelAnimation','heightAnimation','tiltScreenAnimation'];
// var buttonSeq180 = ['onResetMode', 'onFrontClick', 'onTopClick', 'onRightClick', 'onLeftClick', 'openCloseClick', 'backliteClick'];
var selectedButton = 'onResetMode';

var position = {
   'currentPos': 'reset',
   'close': 0,
   'nintyDegree': 1.04167,
   'reset': 2.08333,
   'top': 1.583,
   'tent': 3.125,
   'theatre': 4.1667,
   'tablet': 5.208,
}

const MainMenu = (props) => {
   const [expandedPanel,setExpandedPanel] = useState(false);

   const [frontImg,setfrontImg] = useState("./img/front.png");
   const [portImg,setPortImg] = useState("./img/back_white.png");
   const [monitorPivotImg,setMonitorPivotImg] = useState("./img/pilot_white.png");
   const [monitorSwivelImg,setMonitorSwivelImg] = useState("./img/swivel_white.png");
   const [monitorHeightImg,setMonitorHeightImg] = useState("./img/height_white.png");
   const [monitorTiltImg,setMonitorTiltImg] = useState("./img/tilt_white.png");
   const [monitorColorometerImg,setMonitorColorometerImg] = useState("./img/colorometer_white.png");
   const [monitorHoodImg,setMonitorHoodImg] = useState("./img/hood_white.png");

   //   const [orientationPotrait, setOrientation] = useState(true);
   //   window.checkOrientationStatus = (orientationStatus) => 
   //   {
   //   //  alert(window.screen.orientation.type);
   //     setOrientation(orientationStatus);
   //  }

   const handleAccordionChange = (panel) => (event,isExpanded) => {
      console.log({ event,isExpanded });
      //setExpandedPanel(isExpanded ? panel  : false );
      if (isExpanded) {
         setExpandedPanel(panel);
         //console.log("shubham");
      } else {
         //  console.log("Pawar");
         setExpandedPanel(false)
      };
      // resetBacklitCloseImg();

   };
   const [camData,setCamData] = useState("");
   var animationSwitch = window.localStorage.getItem('Animation');
   var animTime = 1;
   var animTimes = 1;

   const getData = () => {
      fetch('./model_gl/config.json')
         .then(function (response) {
            return response.json();
         })
         .then(function (myJson) {
            // console.log(myJson.positions);
            setCamData(myJson.positions);
         });
   }
   useEffect(() => {
      getData();
      window.getLangTranscript();
      animationSwitch = window.localStorage.getItem('Animation');
      moblandscap = (mob && window.innerWidth > window.innerHeight);

      //window.localStorage.setItem('tent', false);
      //window.localStorage.setItem('tablet', false);
      //window.localStorage.setItem('theater', false);
      //window.localStorage.setItem('close', false);
      window.localStorage.setItem("position","reset");
      // document.querySelector('#blackBtn').classList.add('Mui-disabled');
      // document.querySelector('#blackBtn').style.pointerEvents = 'none';
      // document.getElementById('whiteBtn').classList.add('select');
      // alert('moblandscap '+moblandscap )
   },[]);

   useEffect((event) => {
      if (event) {
         if (event.keyCode === 13) {
            this.click();
         }
      }

      // alert('Counter in useEffect'+prevCounter);
      // alert('Counter in useEffect'+counter);

   },[])
   useEffect((event) => {
      if (event) {
         if (event.keyCode === 13) {
            this.click();
         }
      }
      //     var isipad = navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1);

      // let mob = (navigator.userAgent.indexOf("iPhone") != -1) || ((navigator.userAgent.indexOf("Android") != -1) || (navigator.userAgent.indexOf("Mobile") != -1)) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15");

      // alert('Counter in useEffect'+prevCounter);
      // alert('Counter in useEffect'+counter);

   })
   const [animStoped,setanimStoped] = useState(true);

   const animComplete = () => {
      setanimStoped(true);
      var g_navEnabled = true;
      // document.getElementById("onReset").style.pointerEvents = "all";
   }

   //For Animation Switch 
   // console.log('animationSwitch anim', animationSwitch)

   if (animationSwitch == 'on') { animTime = 1000; animTimes = 2000 }
   else { animTime = 1; animTimes = 1 }
   // console.log('animTime', animTime)

   //new camera function
   const GotoPosInTimeNamedValue = (gotoposname,onComplete,onSample) => {
      // below code is updated in it.  
      // updated code ends here

      var opt = undefined,gp = camData[gotoposname];

      //    console.log(gp)
      if (gp.fovy && window.scene.fovy != gp.fovy)
         opt = { fovy: gp.fovy };
      if (gp.pos.length > 5) {
         if (!opt)
            opt = {};
         opt.zang = gp.pos[5];
      }
      // console.log('animationSwitch', animationSwitch)
      if (animationSwitch == 'off') {
         gp.time = 1
         // console.log('animationSwitch iffff', gp.time)
      }
      else {
         gp.time = animTime;
         // console.log('animationSwitch elseeee', gp.time)
      }
      console.log('animationSwitch',animationSwitch);
      console.log('gp.time',gp.time);
      window.scene.gotoPosInTime(gp.pos[0],gp.pos[1],gp.pos[2],gp.pos[3],gp.pos[4],gp.time,onComplete,slowInOut,opt);
      // console.log(gp.pos[0], gp.pos[1], gp.pos[2], gp.pos[3], gp.pos[4], gp.time, onComplete, onSample, opt);
   }
   //end
   const slowInOut = (x) => {
      var a = 2.1;
      var x2 = 1.0 - x;
      var px = Math.pow(x,a);
      var px2 = Math.pow(x2,a);

      return px / (px + px2);
   }



   const reversAll = () => {

      window.scene.animPlayInTime("calibration",0,1);
      window.scene.animPlayInTime("BOX",0,1);

      // window.playVideo = false;
      // var tex = window.scene._Texture_ref["screen_image.jpg"];
      // var texture = window.scene._Textures[tex.tex_id];
      // console.log(texture)
      // if (texture != null) {
      //    var gl = window.scene.gl;
      //    gl.bindTexture(gl.TEXTURE_2D,texture);
      //    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
      //    gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,
      //       gl.RGBA,gl.UNSIGNED_BYTE,window.staticImage);
      // }
      // window.scene.groupApplyState("Tilt_21_&_5_on");
      // window.scene.groupApplyState("Up_Down_70_mm_on");
      window.localStorage.removeItem('hotspot');
      window.scene.groupApplyState('stand_on');
      window.scene.groupApplyState('ref_on');
      window.scene.clearRefine();

   }

   const reverAnimation = () => {

      // if (window.scene.animIsPlaying("swivel_rotation")) window.scene.getAnim("swivel_rotation").stop();
      // if (window.scene.animIsPlaying('hinge_rotate')) window.scene.getAnim("hinge_rotate").stop();
      // if (window.scene.animIsPlaying('hing_move')) window.scene.getAnim("hing_move").stop();
      // if (window.scene.animIsPlaying('swivel_rotation')) window.scene.getAnim("swivel_rotation").stop();
      // if (window.scene.animIsPlaying('hinge_02_Rotate')) window.scene.getAnim("hinge_02_Rotate").stop();
      // if (window.scene.animIsPlaying('screen_rotate')) window.scene.getAnim("screen_rotate").stop();
      // if (window.scene.animIsPlaying('calibration')) window.scene.getAnim("calibration").stop();
      // if (window.scene.animIsPlaying('BOX')) window.scene.getAnim("BOX").stop();

      // window.scene.animPlayInTime("hinge_rotate",0,0);
      // window.scene.animPlayInTime("hing_move",0,0);
      // window.scene.animPlayInTime("swivel_rotation",0,0);
      // window.scene.animPlayInTime("hinge_02_Rotate",0,0);
      // window.scene.animPlayInTime("screen_rotate",0,0);
      // window.scene.animPlayInTime("calibration",0,0);
      // window.scene.animPlayInTime("BOX",0,0);

      if (window.scene.animIsPlaying("Height_Adjustable_Anim")) window.scene.getAnim("Height_Adjustable_Anim").stop();
      if (window.scene.animIsPlaying("SCREEN_Tilt")) window.scene.getAnim("SCREEN_Tilt").stop();
      if (window.scene.animIsPlaying("Pivot_Anim")) window.scene.getAnim("Pivot_Anim").stop();
      if (window.scene.animIsPlaying("Swiel_Rotation")) window.scene.getAnim("Swiel_Rotation").stop();
      if (window.scene.animIsPlaying("DE_1397_CA__C2423H")) window.scene.getAnim("DE_1397_CA__C2423H").stop();

      window.scene.animPlayInTime("Height_Adjustable_Anim",0,0);
      window.scene.animPlayInTime("SCREEN_Tilt",0,0);
      window.scene.animPlayInTime("Pivot_Anim",0,0);
      window.scene.animPlayInTime("Swiel_Rotation",0,0);
      window.scene.animPlayInTime("DE_1397_CA__C2423H",0,0);
      window.scene.clearRefine();
   }

   const hideGraphics = () => {
      window.scene.groupApplyState("45_Degree_off");
      window.scene.groupApplyState("90_degree_off");
      // window.scene.groupApplyState("Tilt_21_&_5_on");
      // window.scene.groupApplyState("Up_Down_70_mm_on");
      window.scene.clearRefine();

   }
   //MenuProductView
   const onfrontClick = (isNextPrevious) => {
      //Update ZoomBar
      var slider = document.getElementById("sliderRange");
      window.scene._nav.tempfRotMinLimit = 0.001;
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('frontBtn').classList.add('active');
      window.localStorage.setItem("position","reset");

      selectedButton = 'onfrontClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','fronts view');
         document.getElementById('nextView').setAttribute('aria-label','fronts view');
      }
      reversAll();
      reverAnimation();
      window.localStorage.removeItem('hotspot');
      window.scene.clearRefine();
      window.scene.groupApplyState('stand_on');
      window.scene.groupApplyState('Reflection_Box_On');

      GotoPosInTimeNamedValue('Front_Cam_F0',function () {
         window.scene.groupApplyState('Reflection_Box_On');
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }
         window.localStorage.setItem('hotspot','colorometer');

      });

      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");

         document.getElementById("hotspot11").setAttribute("tabindex","1");
         document.getElementById("hotspot12").setAttribute("tabindex","1");
         document.getElementById("hotspot13").setAttribute("tabindex","1");
         document.getElementById("hotspot14").setAttribute("tabindex","1");

         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");

      }
      window.RT_RecordEvent("Product View","fronts",window.config.name);
      window.scene.clearRefine();

   }

   const onPortClick = (isNextPrevious) => {
      //Update ZoomBar
      var slider = document.getElementById("sliderRange");
      window.scene._nav.tempfRotMinLimit = 0.48;
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('portBtn').classList.add('active');
      window.localStorage.setItem("position","reset");

      selectedButton = 'onPortClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Ports view');
         document.getElementById('nextView').setAttribute('aria-label','Ports view');
      }
      reversAll();
      reverAnimation();
      window.localStorage.removeItem('hotspot');
      window.scene.clearRefine();
      window.scene.groupApplyState('Reflection_Box_off');
      GotoPosInTimeNamedValue('Ports_Cam_F0',function () {
         window.scene.groupApplyState('Stand_OFF');
         window.scene.groupApplyState('GP_Off');
         window.scene.groupApplyState('ref_off');
         window.scene.groupApplyState('Reflection_Box_off');

      });
      setTimeout(function () {
         GotoPosInTimeNamedValue('Ports_Cam_F0',function () {
            if (isNextPrevious != true) {
               window.document.getElementById("hotspot1demo").focus();
            }
         });
         setTimeout(function () {
            window.scene.groupApplyState('Stand_OFF');
            window.scene.groupApplyState('GP_Off');
            window.scene.groupApplyState('ref_off');
            GotoPosInTimeNamedValue('Ports_Cam_F0',function () {
               window.localStorage.setItem('hotspot','top');
               window.document.getElementById("hotspot1demo").focus();
               animComplete();
            });
         },1200);
      },1200);
      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot1").setAttribute("tabindex","1");
         document.getElementById("hotspot2").setAttribute("tabindex","1");
         document.getElementById("hotspot3").setAttribute("tabindex","1");
         document.getElementById("hotspot4").setAttribute("tabindex","1");
         document.getElementById("hotspot5").setAttribute("tabindex","1");
         document.getElementById("hotspot6").setAttribute("tabindex","1");
         document.getElementById("hotspot7").setAttribute("tabindex","1");
         document.getElementById("hotspot8").setAttribute("tabindex","1");
         document.getElementById("hotspot9").setAttribute("tabindex","1");
         document.getElementById("hotspot10").setAttribute("tabindex","1");
         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("hotspot12").setAttribute("tabindex","-1");
         document.getElementById("hotspot13").setAttribute("tabindex","-1");
         document.getElementById("hotspot14").setAttribute("tabindex","-1");

         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");

      }
      window.RT_RecordEvent("Product View","Ports",window.config.name);
      window.scene.clearRefine();

   }

   //menuColor

   //MenuFeatureView


   const shadingHoodClick = (isNextPrevious) => {
      console.log('shadingHoodClick')
      window.scene._nav.tempfRotMinLimit = 0.001;
      //Update ZoomBar
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }


      selectedButton = 'shadingHoodClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Shading Hood');

         document.getElementById('nextView').setAttribute('aria-label','Shading Hood');
      }

      var fromPos = window.localStorage.getItem('hotspot')
      window.localStorage.removeItem('hotspot');
      window.localStorage.setItem('closeMode','on');
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      reversAll();
      reverAnimation();
      hideGraphics();
      // window.playVideo = false;
      // var tex = window.scene._Texture_ref["screen_image.jpg"];
      // var texture = window.scene._Textures[tex.tex_id];
      // console.log(texture)
      // if (texture != null) {
      //    var gl = window.scene.gl;
      //    gl.bindTexture(gl.TEXTURE_2D,texture);
      //    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
      //    gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,
      //       gl.RGBA,gl.UNSIGNED_BYTE,window.staticImage);
      // }
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('shadingHood').classList.add('active');

      GotoPosInTimeNamedValue('Render_Cam_F15_FL',function () {
         window.scene.groupApplyState("Hood_ON");
         window.localStorage.setItem('hotspot','hood');
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }

         animComplete();
      });
      if (!(window.isipad || window.mob)) {

         document.getElementById("hotspot1").setAttribute("tabindex","1");
         document.getElementById("hotspot2").setAttribute("tabindex","1");
         document.getElementById("hotspot3").setAttribute("tabindex","1");
         document.getElementById("hotspot4").setAttribute("tabindex","1");
         document.getElementById("hotspot5").setAttribute("tabindex","1");
         document.getElementById("hotspot6").setAttribute("tabindex","1");
         document.getElementById("hotspot7").setAttribute("tabindex","1");
         document.getElementById("hotspot8").setAttribute("tabindex","1");
         document.getElementById("hotspot9").setAttribute("tabindex","1");
         document.getElementById("hotspot10").setAttribute("tabindex","1");

         document.getElementById("hotspot11").setAttribute("tabindex","1");
         document.getElementById("hotspot12").setAttribute("tabindex","1");
         document.getElementById("hotspot13").setAttribute("tabindex","1");
         document.getElementById("hotspot14").setAttribute("tabindex","1");

         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");
      }
      window.RT_RecordEvent("Features","Shading Hood",window.config.name);
      window.scene.clearRefine();

   }
   let backliteVar = document.getElementById('backlitBtn');

   const colorometerClick = (isNextPrevious) => {
      console.log('colorometerClick')
      //Update ZoomBar
      window.scene._nav.tempfRotMinLimit = 0.001;
      var slider = document.getElementById("sliderRange");
      //
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label',' Built-in Colorometer');

         document.getElementById('nextView').setAttribute('aria-label',' Built-in Colorometer');
      }
      selectedButton = 'colorometerClick';
      reversAll();
      reverAnimation();
      hideGraphics();

      window.localStorage.removeItem('hotspot');
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('colorometer').classList.add('active');

      window.localStorage.setItem("position","reset");
      // var tex = window.scene._Texture_ref["screen_image.jpg"];
      // var texture = window.scene._Textures[tex.tex_id];
      // console.log(texture)
      // if (texture != null) {
      //    var gl = window.scene.gl;
      //    gl.bindTexture(gl.TEXTURE_2D,texture);
      //    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
      //    gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,
      //       gl.RGBA,gl.UNSIGNED_BYTE,window.staticImage);
      // }

      GotoPosInTimeNamedValue('Render_Cam_F15_F',function () {
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }
         window.scene.animPlayInTime("calibration",2.55,1000,function () {
            window.scene.animPlayInTime("BOX",2.55,1800,function () {
               window.localStorage.setItem('hotspot','colorometer');
               window.videoHolder = window.setupVideo('./video/Colorimeter.mp4');
               window.playVideo = true;
               animComplete();
            });
         });

      });
      if (!(window.isipad || window.mob)) {

         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");

         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("hotspot12").setAttribute("tabindex","-1");
         // document.getElementById("hotspot14").setAttribute("tabindex","1");

         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");
      }
      window.RT_RecordEvent("Features","Built-in Colorometer",window.config.name);

      window.scene.clearRefine();
   }


   //Menu Position

   const pivotAnimation = () => {
      console.log("pivotAnimation");
      window.scene._nav.tempfRotMinLimit = 0.001;
      //Update ZoomBar
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('pivotBtn').classList.add('active');

      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Pivot Monitor');

         document.getElementById('nextView').setAttribute('aria-label','Pivot Monitor');
      }


      window.localStorage.setItem("position","reset");
      selectedButton = 'pivotAnimation';
      reversAll();
      reverAnimation();
      hideGraphics();
      setTimeout(function () {
         console.log("serTimeout");
         window.localStorage.removeItem('hotspot');

      },1000)
      GotoPosInTimeNamedValue('Render_Cam_F01_Pivot',function () {
         // window.scene.groupApplyState('90_degree_on');
         window.scene.animPlayAllChildrenInTime("Swiel_Rotation",0.833,1,function () {
            window.scene.animPlayAllChildrenInTime("Swiel_Rotation",1.66,10000,function () {
               animComplete();
            });
            window.scene.clearRefine();
         });
      });
      window.RT_RecordEvent("Adjustability","Pivot",window.config.name);
      window.scene.clearRefine();
   }

   const swivelAnimation = () => {
      //Update ZoomBar
      console.log("swivelAnimation");
      //Update 
      window.scene._nav.tempfRotMinLimit = 0.001;
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      // document.getElementById('swivelBtn').classList.add('active');

      selectedButton = 'swivelAnimation';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Swivel base');
         document.getElementById('nextView').setAttribute('aria-label','Swivel base');
      }
      window.localStorage.setItem("position","reset");
      window.localStorage.removeItem('hotspot');
      reversAll();
      reverAnimation();
      hideGraphics();

      GotoPosInTimeNamedValue('Render_Cam_F15_Top',function () {
         // window.scene.groupApplyState('45_Degree_on');
         window.scene.animPlayInTime("Swiel_Rotation",1.66,5000,function () {
            animComplete();
         });
      })
      // window.RT_RecordEvent("Adjustability","Swivel",window.config.name);
      window.scene.clearRefine();
   }

   const heightAnimation = () => {
      //Update ZoomBar
      window.scene._nav.tempfRotMinLimit = 0.001;
      console.log("heightAnimation");
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Adjust Height');
         document.getElementById('nextView').setAttribute('aria-label','Adjust Height');
      }

      window.localStorage.removeItem('hotspot');
      reversAll();
      reverAnimation();
      hideGraphics();
      selectedButton = 'heightAnimation';
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('heightBtn').classList.add('active');
      window.scene.groupApplyState('Reflection_Box_On');
      window.localStorage.setItem("position","reset");
      GotoPosInTimeNamedValue('Back_Cam_F0',function () {
         // window.scene.groupApplyState('Up_Down_70_mm_on');
         window.scene.groupApplyState('Reflection_Box_On');
         window.scene.animPlayInTime("Height_Adjustable_Anim",1,2000,function () {
            animComplete();
         });
      });
      window.RT_RecordEvent("Adjustability","Height",window.config.name);
      window.scene.clearRefine();
   }

   const tiltScreenAnimation = () => {
      //Update ZoomBar
      window.scene._nav.tempfRotMinLimit = 0.001;
      console.log("tiltScreenAnimation");
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Tilt Screen');
         document.getElementById('nextView').setAttribute('aria-label','Tilt Screen');
      }
      selectedButton = 'tiltScreenAnimation';
      reversAll();
      reverAnimation();
      hideGraphics();
      window.localStorage.removeItem('hotspot');
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('tiltScreenBtn').classList.add('active');
      window.localStorage.setItem("position","reset");
      window.scene.groupApplyState('Reflection_Box_On');
      GotoPosInTimeNamedValue('Left_Cam_F16',function () {
         // window.scene.groupApplyState('Tilt_21_&_5_on');
         window.scene.groupApplyState('Reflection_Box_On');
         window.scene.animPlayInTime("SCREEN_Tilt",1,4000,function () {
            animComplete();
         });
         window.scene.clearRefine();
      });
      window.RT_RecordEvent("Adjustability","Tilt",window.config.name);
      window.scene.clearRefine();
   }

   const resetMode = () => {
      selectedButton = 'onResetMode';
      GotoPosInTimeNamedValue('Ports_Cam_F0',function () { })
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Reset Mode');
         document.getElementById('nextView').setAttribute('aria-label','Reset Mode');
      }
   }
   const onResetMode = () => {
      //Update ZoomBar
      console.log(position.tent,position.currentPos)

      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      if (selectedButton == 'onfrontClick') {
         console.log("front onreset")

         setTimeout(function () {
            window.scene.groupApplyState('stand_on');
            GotoPosInTimeNamedValue('Front_Cam_F0',function () {
               // window.localStorage.setItem('hotspot','top');
               // window.document.getElementById("hotspot1demo").focus();

               animComplete();
            });
         })
      }
      else if (selectedButton == 'onPortClick') {
         console.log("Port onreset")
         window.scene.groupApplyState('GP_Off');
         setTimeout(function () {
            window.scene.groupApplyState('stand_off');
            GotoPosInTimeNamedValue('Ports_Cam_F0',function () {
               window.localStorage.setItem('hotspot','top');
               window.document.getElementById("hotspot1demo").focus();
               animComplete();
            });
         })
      }
      else if (selectedButton == 'shadingHoodClick') {
         shadingHoodClick();
         GotoPosInTimeNamedValue('Render_Cam_F15_FL',function () {
            window.scene.groupApplyState("Hood_ON");
            window.localStorage.setItem('hotspot','hood');
            window.document.getElementById("hotspot1demo").focus();


            animComplete();
         });

      }
      else if (selectedButton == 'colorometerClick') {
         colorometerClick();

         window.playVideo = true;
         GotoPosInTimeNamedValue('Front_Cam_F0',function () {
            window.scene.animPlayInTime("calibration",2.55,1000,function () {
               window.scene.animPlayInTime("BOX",2.55,1800,function () {
                  window.localStorage.setItem('hotspot','colorometer');

                  animComplete();
               });

            })
         })

      } else if (selectedButton == 'pivotAnimation') {
         pivotAnimation();
         GotoPosInTimeNamedValue('Render_Cam_F01_Pivot',function () {
            // window.scene.groupApplyState('90_degree_on');
            window.scene.animPlayAllChildrenInTime("Swiel_Rotation",0.833,1,function () {
               window.scene.animPlayAllChildrenInTime("Swiel_Rotation",1.66,10000,function () {
                  animComplete();
               });
               window.scene.clearRefine();
            });

         });

      } else if (selectedButton == 'swivelAnimation') {
         swivelAnimation();
         GotoPosInTimeNamedValue('Render_Cam_F15_Top',function () {
            // window.scene.groupApplyState('45_Degree_on');
            window.scene.animPlayInTime("Swiel_Rotation",0.84,5000,function () {
               animComplete();
            });
         })
      } else if (selectedButton == 'heightAnimation') {
         heightAnimation();
         GotoPosInTimeNamedValue('Back_Cam_F0',function () {
            // window.scene.groupApplyState('Up_Down_70_mm_on');
            window.scene.animPlayInTime("Height_Adjustable_Anim",1,2000,function () {
               animComplete();
            });
         });
      } else if (selectedButton == 'tiltScreenAnimation') {
         tiltScreenAnimation();
         GotoPosInTimeNamedValue('Left_Cam_F16',function () {
            // window.scene.groupApplyState('Tilt_21_&_5_on');
            window.scene.animPlayInTime("SCREEN_Tilt",1,4000,function () {
               animComplete();
            });
            window.scene.clearRefine();
         });
      }
      else if (selectedButton == 'onResetMode') {
         resetMode()
         GotoPosInTimeNamedValue('Front_Left_Cam_F0',function () { })
      }
      window.scene.clearRefine();
   }

   const onPreviousMode = () => {

      //Update ZoomBar
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      // alert(selectedButton)
      var prevButton;

      var selectedButtonIndex = buttonSeq.findIndex(element => element === selectedButton)
      if (selectedButton == 'onfrontClick' || selectedButton == 'onResetMode') {
         prevButton = 'tiltScreenAnimation';
      } else if (selectedButton == 'heightAnimation') { prevButton = 'onPortClick'; }
      else {
         prevButton = buttonSeq[selectedButtonIndex - 1];
      }

      // }
      // alert(buttonSeq[selectedButtonIndex+1])



      if (prevButton == 'onfrontClick') onfrontClick(true);
      else if (prevButton == 'onPortClick') onPortClick(true);
      // else if (prevButton == 'shadingHoodClick') shadingHoodClick(true);
      // else if (prevButton == 'colorometerClick') colorometerClick(true);
      // else if (prevButton == 'pivotAnimation') pivotAnimation(true);
      // else if (prevButton == 'swivelAnimation') swivelAnimation(true);
      else if (prevButton == 'heightAnimation') heightAnimation(true);
      // else if (prevButton == 'tiltScreenAnimation') tiltScreenAnimation(true);
      else if (prevButton == 'tiltScreenAnimation') {
         setExpandedPanel("panel3");

         tiltScreenAnimation(true);
      }
      return false;


   }

   const onNextMode = () => {

      //Update ZoomBar
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      var nextButton;
      var selectedButtonIndex = buttonSeq.findIndex(element => element === selectedButton)
      if (selectedButton == 'tiltScreenAnimation') {
         nextButton = 'onfrontClick';
      } else if (selectedButton == 'onPortClick') { nextButton = 'heightAnimation'; }
      else {
         nextButton = buttonSeq[selectedButtonIndex + 1];
      }

      // }
      // alert(laptop180)

      if (nextButton == 'onfrontClick') onfrontClick(true);
      else if (nextButton == 'onPortClick') onPortClick(true);
      // else if (nextButton == 'shadingHoodClick') shadingHoodClick(true);
      // else if (nextButton == 'colorometerClick') colorometerClick(true);
      // else if (nextButton == 'pivotAnimation') pivotAnimation(true);
      // else if (nextButton == 'swivelAnimation') swivelAnimation(true);
      else if (nextButton == 'heightAnimation') heightAnimation(true);
      else if (nextButton == 'tiltScreenAnimation') tiltScreenAnimation(true);
      return false;


   }

   // useEffect(()=>{
   //   getData();
   // },[counter])
   const [animValue,setAnimValue] = useState("On");
   // window.localStorage.setItem('Animation', 'on');

   useEffect(() => {
      window.localStorage.setItem('Animation','on');
      document.getElementById("animSwitchValue").checked = 'true';

      setAnimValue("On");
      document.getElementsByClassName('onOff')[0].style.left = "-17px";

   },[]);

   const setAnimationSwitch = (e) => {
      console.log(e)
      // displayName(e);
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked == true) {
         document.getElementById("animSwitchValue").setAttribute('aria-label','Animation Off');
         document.getElementById("animSwitchValue").checked = false;
         setAnimValue("Off");
         document.getElementsByClassName('onOff')[0].style.left = "9px";
         window.localStorage.setItem('Animation','off');

         window.RT_RecordEvent("Animations","Off",window.config.name);
         //   document.getElementById('animSwitchValue').setAttribute('aria-label', '');
         // document.getElementById('animSwitchValue').innerHTML = 'clickable checkbox checked On';
         // alert("Animation On");

      } else {
         document.getElementById("animSwitchValue").setAttribute('aria-label','Animation On')
         document.getElementById("animSwitchValue").checked = true;

         setAnimValue("On");
         window.localStorage.setItem('Animation','on');
         document.getElementsByClassName('onOff')[0].style.left = "-17px";

         window.RT_RecordEvent("Animations","On",window.config.name);
         // alert("Animation Off");
         //   document.getElementById('animSwitchValue').setAttribute('aria-label', '');
         // document.getElementById('animSwitchValue').innerHTML = 'clickable checkbox checked Off';
      }
   }
   const displayName = (e) => {
      console.log(e)
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked == true) {
         setAnimValue("On");
         window.localStorage.setItem('Animation','on');
         document.getElementsByClassName('onOff')[0].style.left = "-17px";
         document.getElementById('animSwitchValue').setAttribute('aria-label','');
         document.getElementById('animSwitchValue').innerHTML = 'clickable checkbox checked On' + window.finalLangues.On;
         // document.getElementById('animSwitchValue').setAttribute('aria-label','clickable checkbox checked On');
         // alert("Animation On");

      } else {
         setAnimValue("Off");
         document.getElementsByClassName('onOff')[0].style.left = "9px";
         window.localStorage.setItem('Animation','off');
         document.getElementById('animSwitchValue').setAttribute('aria-label','');
         document.getElementById('animSwitchValue').innerHTML = 'clickable checkbox checked Off' + window.finalLangues.Off;
         // document.getElementById('animSwitchValue').setAttribute('aria-label','clickable checkbox checked Off');
         // alert("Animation Off");

      }

   }



   return (
      <>
         {/* <Hidden only={["xs",'sm']}> */}
         {!mob && <HowToUse />}
         {/* </Hidden> */}
         <Hidden only={['sm','md','lg','xl']}>

            <Button style={{ position: 'fixed',backgroundColor: '#F0F0F0',width: '100%',height: '56px',paddingTop: '15px',paddingBottom: '15px',zIndex: '1',border: '1px solid #E1E1E1',borderLeft: "none",borderRight: "none",borderRadius: "0",margin: "-1px 0px 0px 0px" }}
               variant="outlined"
               color="primary"
               // className={classes.button}
               endIcon={<img src="./img/cross.svg" alt="cross" style={{ marginLeft: '207px',height: '23px' }} />}
               onClick={props.toggleDrawerAction}
            >
               Main Menu
            </Button>
            <Howtousenew />

         </Hidden>
         <Hidden only={['md','lg','xl','xs']}>
            {moblandscap && <Howtousenew />}
         </Hidden>

         <Hidden only={["xs"]}>
            <FooterControl name="reset and next previous" onReset={onResetMode} onPrevious={onPreviousMode} onNext={onNextMode} />
         </Hidden>
         <Hidden only={['lg','xl']}>
            <FooterControlMob onResetMob={onResetMode} onPreviousMob={onPreviousMode} onNextMob={onNextMode} onResetIpad={onResetMode} onNextIpad={onNextMode} onPreviousIpad={onPreviousMode} />
         </Hidden>
         {/* <MenuSelectProductType tabIndex="1" name="Select Product Type" onclicked={laptopClick} onclickedtwo={select2in1Click} value={value} expanded={expandedPanel === 'panel5'} onChanged={handleAccordionChange('panel5')}/> */}
         {/* <userContext.Provider value=""> */}
         {/* <MenuColors id="menuColor" tabIndex="1" name="Colors" onWhiteBtnClick={color1Click} onBlackBtnClick={color2Click} expanded={expandedPanel === 'panel4'} onChanged={handleAccordionChange('panel4')} /> */}
         {/* </userContext.Provider> */}
         {/* <MenuPositions name="Adjustability" tabIndex="1" onTentMode={TentModeClick} onTheaterMode={TheaterModeClick} onTabletMode={TabletModeClick} expanded={expandedPanel === 'panel2'} onChanged={handleAccordionChange('panel2')}/> */}

         <MenuProductView name={window.finalLangues.productview}  tabIndex="1" onfrontBtnClick={onfrontClick}
            onPortBtnClick={onPortClick} imgfront={frontImg} imgport={portImg} expanded={expandedPanel === 'panel1'} onChanged={handleAccordionChange('panel1')} />

         {/* <MenuFeatures name="Features" tabIndex="1" onShadingHoodClicked={shadingHoodClick}  onColorometerClicked = {colorometerClick} imgcolorometer={monitorColorometerImg} imghood={monitorHoodImg} expanded={expandedPanel === 'panel3'} onChanged={handleAccordionChange('panel3')}/> */}

         <MenuAdjustability name={window.finalLangues.adjust} tabIndex="1" heightAnim={heightAnimation} tiltScreenAnim={tiltScreenAnimation} imgpivot={monitorPivotImg} imgswivel={monitorSwivelImg} imgheight={monitorHeightImg} imgtilt={monitorTiltImg} expanded={expandedPanel === 'panel5'} onChanged={handleAccordionChange('panel5')} />

         <AnimationBtn onchange={displayName} forKeypress={setAnimationSwitch} value={animValue} />

      </>
   );
}

export default MainMenu;